import NOTIFICATIONS_API from 'api/notifications/v1'
import i18next from 'i18next'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import i18n from 'i18nProduct'
import { notificationShow } from 'modules/Notifications/actions'
import { FETCH_TICKETS_COUNTER, SET_I18N, SET_TICKETS_COUNTER } from 'modules/App/types'
import { UPDATE_USER_LOCALE } from 'modules/User/Profile/store/types'

export function* updateLangData(action) {
  global.__localeId__ = action.payload.i18n

  i18n.changeLanguage(action.payload.i18n)

  yield put({
    type: UPDATE_USER_LOCALE,
    payload: { locale: action.payload.i18n },
  })
}

export function* fetchTicketsCounter() {
  const { ticketsCounter, i18n } = yield select(({ app }) => app)

  try {
    const { response, error } = yield call(NOTIFICATIONS_API.fetch, {
      params: { types: ['ticket'] },
    })

    if (error) {
      throw error
    }

    if (response?.data) {
      if (
        (response.data[0].count > ticketsCounter || ticketsCounter === undefined) &&
        response.data[0].count > 0
      ) {
        yield put(
          notificationShow({
            type: 'success',
            message: i18next.t('common::notifications.tickets_updated', {
              i18n,
            }),
          }),
        )
      }

      yield put({
        type: SET_TICKETS_COUNTER,
        payload: response?.data?.[0].count || 0,
      })
    }
  } catch (error) {
    console.logXHR(error)
  }
}

export function* updateDrawerState() {}

export function* Sagas() {
  yield takeLatest(SET_I18N, updateLangData)
  yield takeLatest(FETCH_TICKETS_COUNTER, fetchTicketsCounter)
}
